// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdb1cf88","884":"8d7e4b98","889":"a2382cdd","940":"445c87b4"}[chunkId] + ".chunk.js";
};